import INVENTORY_API_BASE_URL from "../../config/api";
import "./ApprovePO.css";
import { useState, useEffect } from "react";
import Axios from "axios";
import React from "react";
import Table from "react-bootstrap/Table";
import swal from "sweetalert";
import logUserActivity from "../utils/logUserActivity";

function ApprovePO() {
  const [data, setData] = useState([]);
  const [ApprovalDate, setApprovalDate] = useState();
  const [approved, setapproved] = useState();
  const [orderquantity, setorderquantity] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [approvedOrderValue, setapprovedOrderValue] = useState();

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setData(response.data);
    });
  }, []);

  const deleteOrder = (id) => {
    swal({
      title: "Reject this order?",
      text: "This will permanently delete the order.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (confirmed) => {
      if (!confirmed) return;

      try {
        await Axios.delete(`${INVENTORY_API_BASE_URL}/delete/${id}`);
        await logUserActivity("DELETE_ORDER", { orderId: id });
        swal("Order rejected successfully!", { icon: "success" }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        console.error("Unable to reject order:", error);
        swal("The order could not be rejected.", { icon: "error" });
      }
    });
  };

  const giveDate = async (id, approvedquantity, approvedvalue) => {
    if (approved === undefined) {
      swal({
        title: "Please enter Approved Quantity",
        text: "",
        icon: "warning",
      });
      return;
    }

    if (!ApprovalDate) {
      swal({
        title: "Please select Date",
        text: "",
        icon: "warning",
      });
      return;
    }

    try {
      await Axios.put(`${INVENTORY_API_BASE_URL}/ApprovePO`, {
        id: id,
        ApprovalDate: ApprovalDate,
        updatedQuantity: approved,
        approvedOrderValue: approvedOrderValue,
      });

      await logUserActivity("APPROVE_ORDER", {
        orderId: id,
        ApprovalDate,
        updatedQuantity: approved,
        approvedOrderValue,
      });

      swal({
        title: "Order Approved",
        text: "",
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    } catch (err) {
    }
  };

  function calculatePurchaseValue(quantity, purchasePrice) {
    return quantity * purchasePrice;
  }

  const handleQuantityChange = async (event, rowId, sku, orderid) => {
    const { value } = event.target;
    setData((prevData) => {
      const updatedData = prevData.map((rowData) => {
        if (rowData._id === rowId) {
          const updatedOrder = rowData.list.map((item) =>
            item.sku === sku
              ? {
                  ...item,
                  approvedquantity: value,
                  total: calculatePurchaseValue(value, item.purchasePrice),
                }
              : item
          );

          setapproved(updatedOrder);
          return { ...rowData, list: updatedOrder };
        }
        return rowData;
      });

      return updatedData;
    });

    await logUserActivity("UPDATE_APPROVED_QUANTITY", {
      orderId: orderid,
      sku,
      newApprovedQuantity: value,
    });
  };

  const filteredData = data.filter((row) => {
    const orderSkuMatch =
      row.orderid.toString().includes(searchInput) ||
      row.list.some(
        (item) =>
          item.batchid?.toLowerCase().includes(searchInput.toLowerCase()) ||
          item.title?.toLowerCase().includes(searchInput.toLowerCase())
      );
    return orderSkuMatch;
  });

  return (
    <div className="ApprovePO">
      <h4 className="approveheading">Approve Purchase Order</h4>

      <input
        className="approvesearch1"
        type="text"
        placeholder="Search by OrderId,BatchID,Title"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />

      <br />
      <div className="approvecontainer">
        <div className="approvecontent">
          <Table className="krin">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Batch ID</th>
                <th>Image</th>
                <th>Title</th>
                <th>Medium</th>
                <th>Quantity</th>
                <th>Approved Quantity</th>
                <th>Purchase price</th>
                <th>MRP</th>
                <th>Total</th>
                <th>Approval Date & Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((row, rowIndex) => {
                let grandTotal = 0;

                return (
                  <React.Fragment key={row.orderid}>
                    {row.list.map((item, index) => {
                      grandTotal += item.total;
                      const isHighlighted =
                        searchInput && item.batchid.includes(searchInput);
                      return (
                        <tr
                          key={item.sku}
                          className={isHighlighted ? "highlight-row" : ""}
                        >
                          {index === 0 ? (
                            <td rowSpan={row.list.length}>{row.orderid}</td>
                          ) : null}
                          <td>
                            <span
                              className={
                                isHighlighted ? "highlight-batchid" : ""
                              }
                            >
                              {item.batchid}
                            </span>
                          </td>

                          <td>
                            <img
                              src={`https://d10idqgatxnd06.cloudfront.net/${item.img}`}
                              alt="image1"
                              width="70"
                              height="70"
                            />
                          </td>
                          <td style={{ width: "1rem" }}>{item.title}</td>
                          <td>{item.Medium}</td>
                          <td>{item.quantity}</td>
                          <td>
                            <input
                              type="number"
                              value={item.approvedquantity}
                              onChange={(e) =>
                                handleQuantityChange(
                                  e,
                                  row._id,
                                  item.sku,
                                  row.orderid
                                )
                              }
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>
                          <td>{item.purchasePrice}</td>
                          <td>{item.mrp}</td>
                          <td>
                            {typeof item.total === "number"
                              ? item.total.toFixed(2)
                              : "N/A"}
                          </td>
                          {index === 0 ? (
                            <td
                              rowSpan={row.list.length}
                              style={{ padding: "1.5rem" }}
                            >
                              {row.ApprovalDate === null ? (
                                <div>
                                  <input
                                    type="date"
                                    placeholder="Date of approval"
                                    onChange={(e) => {
                                      setApprovalDate(e.target.value);
                                    }}
                                  />
                                  <button
                                    className="approvebutton"
                                    onClick={() => {
                                      giveDate(row._id);
                                    }}
                                  >
                                    Approve
                                  </button>
                                </div>
                              ) : (
                                <h5>Approved</h5>
                              )}

                              <button
                                className="rejectbutton"
                                onClick={() => {
                                  deleteOrder(row._id);
                                }}
                              >
                                Reject
                              </button>
                            </td>
                          ) : null}
                        </tr>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default ApprovePO;
